import { useVideoCallStore } from './videoCall.store'

export function secondRoleGet(): string {
  const videoCallStore = useVideoCallStore()
  if (videoCallStore.connectionUser?.isHost) return 'host'
  if (videoCallStore.connectionUser?.isFake) return 'fake'
  return 'user'
}
